export const employeeWagesTypeConstant = [
    { name: "Monthly", value: "monthly" },
    { name: "Hourly", value: "hourly" }
];


export const monthlyStatusConstants = 'monthly'
export const hourlyStatusConstants = 'hourly'